import * as React from "react";
import { useTranslation } from "react-i18next";
import { FunctionComponent } from "react";

//MUI Icons
import AddIcon from "@mui/icons-material/Add";

//Custom Components
import CardActionButton from "@/ui/Card/CardActionButton";

//Types
import { ICardActionButtonDetail } from "@/@types/ui/Card";

const CardActionButtonAdd: FunctionComponent<ICardActionButtonDetail> = (props) => {
  const { t } = useTranslation();

  return (
    <CardActionButton startIcon={<AddIcon />} {...props} ariaLabel="Add" ariaControls="Add">
      {t("buttons.add")}
    </CardActionButton>
  );
};

export default CardActionButtonAdd;
